/**
 * Image Zoom Feature
 * Provides hover-to-zoom and click-to-expand functionality
 */

(function() {
  'use strict';

  class ImageZoom {
    constructor(container) {
      this.container = container;
      this.image = container.querySelector('img');
      if (!this.image) return;

      this.isZoomed = false;
      this.zoomLevel = 2.5;

      this.init();
    }

    init() {
      // Create zoom lens element
      this.lens = document.createElement('div');
      this.lens.className = 'image-zoom__lens';
      this.container.appendChild(this.lens);

      // Create zoom icon
      this.icon = document.createElement('div');
      this.icon.className = 'image-zoom__icon';
      this.icon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          <line x1="11" y1="8" x2="11" y2="14"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
      `;
      this.container.appendChild(this.icon);

      // Wait for image to load
      if (this.image.complete) {
        this.setupZoom();
      } else {
        this.image.addEventListener('load', () => this.setupZoom());
      }

      // Event listeners
      this.container.addEventListener('mousemove', (e) => this.handleMove(e));
      this.container.addEventListener('mouseleave', () => this.handleLeave());
      this.container.addEventListener('click', (e) => this.handleClick(e));

      // Touch support
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
      this.container.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
      this.container.addEventListener('touchend', () => this.handleLeave());
    }

    setupZoom() {
      // Set background image for zoom lens
      const highResSrc = this.image.dataset.zoomSrc || this.image.src.replace(/width=\d+/, 'width=2000');
      this.lens.style.backgroundImage = `url(${highResSrc})`;
    }

    handleMove(e) {
      const rect = this.container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      this.lens.style.backgroundPosition = `${x}% ${y}%`;
    }

    handleLeave() {
      // Optional: could reset zoom state
    }

    handleClick(e) {
      e.preventDefault();
      this.openModal();
    }

    handleTouchStart(e) {
      if (e.touches.length === 1) {
        this.container.classList.add('is-zoomed');
        this.handleTouchMove(e);
      }
    }

    handleTouchMove(e) {
      if (e.touches.length === 1) {
        const touch = e.touches[0];
        const rect = this.container.getBoundingClientRect();
        const x = ((touch.clientX - rect.left) / rect.width) * 100;
        const y = ((touch.clientY - rect.top) / rect.height) * 100;

        this.lens.style.backgroundPosition = `${x}% ${y}%`;
      }
    }

    openModal() {
      // Create modal if it doesn't exist
      let modal = document.querySelector('.image-zoom-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'image-zoom-modal';
        modal.innerHTML = `
          <button class="image-zoom-modal__close" aria-label="Close zoom">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="image-zoom-modal__content">
            <img class="image-zoom-modal__image" src="" alt="">
          </div>
        `;
        document.body.appendChild(modal);

        // Close button
        modal.querySelector('.image-zoom-modal__close').addEventListener('click', () => {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });

        // Click outside to close
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });

        // Escape key to close
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });
      }

      // Set image and open
      const highResSrc = this.image.dataset.zoomSrc || this.image.src.replace(/width=\d+/, 'width=2000');
      modal.querySelector('.image-zoom-modal__image').src = highResSrc;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  // Initialize on DOM ready
  function initImageZoom() {
    const zoomContainers = document.querySelectorAll('.image-zoom, .print-configurator__main-image');
    zoomContainers.forEach(container => {
      if (!container.dataset.zoomInit) {
        container.classList.add('image-zoom');
        new ImageZoom(container);
        container.dataset.zoomInit = 'true';
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageZoom);
  } else {
    initImageZoom();
  }

  // Also run when new content is loaded (for AJAX)
  document.addEventListener('shopify:section:load', initImageZoom);
})();
